import type {
  BizminerImprovementLever,
  BizminerPillarInsight,
} from "@/types/serializers";
import ImprovementLeverLayout from "./_components/ImprovementLeverLayout";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ActionsProps {
  pillar_insight: BizminerPillarInsight;
  improvement_lever: BizminerImprovementLever;
  current_tab: string;
}

export default function Actions({
  pillar_insight,
  improvement_lever,
  current_tab,
}: ActionsProps) {
  const handleIdentifySolution = () => {
    alert(
      `Starting solution engine for improvement lever: ${improvement_lever.title}. This feature will be implemented with backend integration.`,
    );
  };

  const handleExport = (format: string) => {
    alert(
      `Exporting opportunity to ${format}. This feature will be implemented with backend integration.`,
    );
  };

  return (
    <ImprovementLeverLayout
      pillar_insight={pillar_insight}
      improvement_lever={improvement_lever}
      current_tab={current_tab}
    >
      <div className="space-y-8">
        {/* Identify Solution Section */}
        <div className="bg-card border border-border rounded-lg p-6">
          <h3 className="text-lg font-semibold text-card-foreground mb-6">
            Identify solution
          </h3>

          <div className="mb-6">
            <p className="text-sm text-muted-foreground leading-relaxed mb-6">
              Vitelis enables you to identify alternative solutions for each
              prioritized improvement lever. Based on the world's leading
              solutioning engine, we provide immediate transparency on potential
              solutions, providers, and proven best practices.
            </p>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6">
              Just click on the "Identify solution" button to start the solution
              engine on this improvement lever.
            </p>
          </div>

          <div className="flex justify-center">
            <Button
              size="lg"
              onClick={handleIdentifySolution}
              className="px-8 py-3"
            >
              Identify solution
            </Button>
          </div>
        </div>

        {/* Export Section */}
        <div className="bg-card border border-border rounded-lg p-6">
          <h3 className="text-lg font-semibold text-card-foreground mb-6">
            Export opportunity
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Button
              variant="secondary"
              onClick={() => handleExport("CSV File")}
              className="flex items-center justify-center space-x-2 w-full"
            >
              <Download className="w-4 h-4" />
              <span>.CSV File</span>
            </Button>

            <Button
              variant="secondary"
              onClick={() => handleExport("Corporate LLM")}
              className="flex items-center justify-center space-x-2 w-full"
            >
              <Download className="w-4 h-4" />
              <span>Corporate LLM</span>
            </Button>

            <Button
              variant="secondary"
              onClick={() => handleExport("MS Project")}
              className="flex items-center justify-center space-x-2 w-full"
            >
              <Download className="w-4 h-4" />
              <span>MS Project</span>
            </Button>
          </div>

          <p className="text-xs text-muted-foreground mt-4 text-center">
            Export functionality will be available with backend integration
          </p>
        </div>
      </div>
    </ImprovementLeverLayout>
  );
}
